<template>
  <v-dialog persistent v-model="dialog" max-width="800px">
    <v-btn
      icon
      slot="activator"
    >
      <v-icon color="primary">edit</v-icon>
    </v-btn>
    <v-card>
      <v-card-title class="primary">
        <span class="headline white--text">Gastgeber bearbeiten</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout wrap>
              <v-flex xs6>
                <v-text-field
                  label="Vorname"
                  v-model="localHost.forename"
                  :disabled="loading"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  label="Nachname"
                  v-model="localHost.surname"
                  :disabled="loading"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  label="Email"
                  required
                  v-model="localHost.email"
                  :rules="emailRules"
                  :disabled="loading"></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
        <small>*Pflichtfelder</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click.native="dialog = false">Abbrechen</v-btn>
        <v-btn color="primary" @click.native="update()" :loading="loading">Aktualisieren</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import {mapActions} from 'vuex';

  export default {
    name: 'DlgHostUpdate',
    props: ['host'],
    data() {
      return {
        dialog: false,
        localHost: {},
        loading: false,
        valid: true,
        emailRules: [
          (v) => !!v || 'E-mail ist ein Pflichtfeld',
          (v) => /.+@.+/.test(v) || 'E-mail ist ungültig',
        ],
        genders: [
          {
            text: 'Weiblich',
            value: 'female',
          },
          {
            text: 'Männlich',
            value: 'male',
          },
        ],
      };
    },
    methods: {
      ...mapActions({
        updateHost: 'admin/hosts/update',
        readHosts: 'admin/hosts/read',
      }),
      update() {
        if (this.$refs.form.validate()) {
          this.loading = true;
          this.updateHost(this.localHost).then((success) => {
            this.loading = false;
            if (success) {
              this.readHosts();
              this.localHost = {};
              this.dialog = false;
            }
          });
        }
      },
    },
    watch: {
      dialog() {
        this.localHost = JSON.parse(JSON.stringify(this.host));
      },
    },
  };
</script>

<style scoped>

</style>
